<template>
   <div>
      <modal-jaleklinico-imagem ref="modalJaleklinicoImagem" :caso_id="jaleklinico.id"
         :imagem="imagemAtual" :pergunta_id="idPerguntaImagem"/>
      <section class="jaleklinico container">
         <div class="d-flex align-items-center mb-4">
            <img src="@/assets/img/jaleklinico/icon-robo.png" class="img-fluid mr-2 mb-1" />
            <h2><strong>Jaleklínico</strong></h2>
         </div>
         <div v-if="!carregandoJaleklinico">
            <div class="row justify-content-center">
               <div class="col-12 col-md-12 mb-5">
                  <div class="box-caso">
                     <div class="caso-desc">
                        <h2> {{ casoGrandeArea }} </h2>
                        <p> {{ jaleklinico.jaleklinico }} </p>
                        <p> {{ jaleklinico.persona }} </p>
                     </div>
                     <div class="chat-jaleklinico">
                        <div v-for="(chat, key) in chat" :key="key" class="chat-jaleklinico-interno">
                           <div class="caso-chat">
                              <div class="row no-gutters">
                                 <div class="col-12 col-md-3 text-center">
                                    <img src="@/assets/img/jaleklinico/perfil-jaleklinico.png" alt="Robozinho Jaleklinico" class="avatar-jaleklinico img-fluid" />
                                 </div>
                                 <div class="col-12 col-md-9 px-4 px-md-0 pr-md-5">
                                    <div class="box-chat">
                                       <p>Jaleklínico</p>
                                       <span v-if="chat.imagem_nomes">
                                          <p></p>
                                          <p v-html="$sanitize(chat.pergunta)"></p>
                                          <span v-for="imagem in chat.imagem_nomes" :key="imagem.id">
                                             <a href="javascript:void(0)" @click="modalImagem(imagem, chat.id)">
                                             <img :src="obterUrlS3(imagem, chat.id)" width="150px"/>
                                             </a>
                                             <p>(clique na imagem para ampliar)</p>
                                             <p>{{ imagem.descricao }}</p>
                                          </span>
                                       </span>
                                       <p v-html="$sanitize(chat.pergunta)" v-else></p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="caso-chat">
                              <div class="row no-gutters">
                                 <div class="col-12 col-md-3 text-center">
                                    <img :src="avatar" alt="Robozinho Jaleklinico" class="avatar-jaleklinico img-fluid" />
                                 </div>
                                 <div class="col-12 col-md-9 px-4 px-md-0 pr-md-5">
                                    <div class="box-chat">
                                       <p id="username">{{ usuario.name }}</p>
                                       <p id="user">{{ chat.resposta }}</p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="caso-chat final chat-jaleklinico-interno">
                           <div class="row no-gutters">
                              <div class="col-12 col-md-3 text-center">
                                 <img src="@/assets/img/jaleklinico/perfil-jaleklinico.png" alt="Robozinho Jaleklinico" class="avatar-jaleklinico img-fluid" />
                              </div>
                              <div class="col-12 col-md-9 px-4 px-md-0 pr-md-5">
                                 <div class="box-chat">
                                    <p>Jaleklínico</p>
                                    <span v-if="perguntaAtual.imagem_nomes">
                                       <p></p>
                                       <p v-html="$sanitize(perguntaAtual.pergunta)"></p>
                                       <span v-for="imagem in perguntaAtual.imagem_nomes" :key="imagem.id">
                                          <a href="javascript:void(0)" @click="modalImagem(imagem, perguntaAtual.id)">
                                          <img :src="obterUrlS3(imagem, perguntaAtual.id)" width="150px"/>
                                          </a>
                                          <p>(clique na imagem para ampliar)</p>
                                          <p>{{ imagem.descricao }}</p>
                                       </span>
                                    </span>
                                    <p v-html="$sanitize(perguntaAtual.pergunta)" v-else></p>
                                       <a v-if="perguntaAtual.link" :href="perguntaAtual.link" target="_blank"> Link externo</a>
                                       <div class="d-flex" v-if="perguntaAtual.video_url">
                                        <iframe v-if="perguntaAtual.video_url" :src="videoUrl(perguntaAtual.video_url)"></iframe>
                                       </div>
                                    <div id="atual" v-if="!perguntaAtual.final">
                                       <b-form-group>
                                          <span v-for="escolha in perguntaAtual.alts" :key="escolha.id">
                                             <b-form-radio-group buttons stacked id="btn-radios-3" v-model="selected" name="radio-btn-stacked">
                                                <b-form-radio :value="escolha.alternativa"
                                                   @change.native="selecionarResposta(perguntaAtual.pergunta, escolha.alvo, escolha.alternativa, escolha.pontos_negativos, perguntaAtual.imagem_nomes, perguntaAtual.id)">{{ escolha.alternativa }}</b-form-radio>
                                             </b-form-radio-group>
                                          </span>
                                       </b-form-group>
                                    </div>
                                    <div id="atual" v-else>
                                       <p><strong>Sua pontuaçao:</strong></p>
                                       <div align="center">
                                          <img :src="medalha" alt="Descriçao da imagem" class="img-fluid mb-4">
                                          <p v-if="false"><strong>Ficou com dúvidas? <a href="#">Acesse nosso video explicativo</a>.</strong></p> <!-- TODO: Colocar link do video -->
                                          <p><strong>O que achou do caso? Avalie e deixe seu comentário:</strong></p>
                                          <p>
                                             <CasoAvaliacao :casoId="jaleklinico.id"></CasoAvaliacao>
                                          </p>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="btns-jaleklinico d-flex justify-content-between">
                        <!-- <b-button v-if="temAcessoARota('btn-jaleklinico-voltar-para-listagem')" class="btn btn-link" href="/jaleklinico">Voltar para os casos</b-button> -->
                        <b-button class="btn btn-secondary" href="javascript:void(0)"  @click="recomecarCaso()" v-if="finalizado">Refazer caso</b-button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div v-else>
            <infinite-loading></infinite-loading>
         </div>
      </section>
   </div>
</template>

<script>

import LoginUtils from '@/core/utils/login-utils'
import ImageUtils from '@/core/utils/image-utils'
import UrlUtils from '@/core/utils/url-utils'
import CasoAvaliacao from '@/modules/Jaleklinico/components/CasoAvaliacao'
import CasosApi from '@/api/casos-api'
import SalaAulaAPI from '@/api/sala-aula-api'
import ModalJaleklinicoImagem from '@/modules/Jaleklinico/components/ModalJaleklinicoImagem'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'TopicoJaleklinico',
  components: {
    CasoAvaliacao,
    ModalJaleklinicoImagem,
    InfiniteLoading
  },
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      chat: [],
      perguntaAtual: {},
      pontuacao: 0,
      jaleklinico: {
        jaleklinico: '',
        id: 0,
        grandes_areas: {
          nome: ''
        }
      },
      perguntas: {},
      primeiraPergunta: '',
      imagemAtual: '',
      carregandoJaleklinico: true,
      selected: '',
      finalizado: false,
      idPerguntaImagem: 0
    }
  },
  async mounted () {
    let idJaleklinico = this.ementaCurso.topico_escolhido.jaleklinico_id
    this.jaleklinico = await CasosApi.obterUmCaso(idJaleklinico)
    let json = JSON.parse(this.jaleklinico.caso)
    let mapPerguntas = new Map()
    for (let i = 0; i < json.length; i++) {
      mapPerguntas.set(json[i].id, json[i])
    }
    this.perguntas = mapPerguntas
    let primeiraPergunta = Object.assign({}, json[0])
    this.perguntaAtual = primeiraPergunta
    this.primeiraPergunta = primeiraPergunta
    this.carregandoJaleklinico = false
  },
  computed: {
    usuario () {
      return LoginUtils.getUsuario()
    },
    casoGrandeArea () {
      if (this.jaleklinico.grandes_areas === null) {
        return 'Caso Generalista'
      }
      return 'Caso de ' + this.jaleklinico.grandes_areas.nome
    },
    avatar: function () {
      if (this.usuario && this.usuario.avatar) {
        return ImageUtils.obterUrlCompletaImagem(this.usuario.avatar)
      }
      return ''
    },
    medalha () {
      if (this.pontuacao < 0 && this.pontuacao > -3) {
        return require('@/assets/img/jaleklinico/prata.png')
      }
      if (this.pontuacao <= -3) {
        return require('@/assets/img/jaleklinico/bronze.png')
      }
      return require('@/assets/img/jaleklinico/ouro.png')
    }
  },
  methods: {
    disableMainScroll () {
      // Get the current page scroll position
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop
      let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

      // if any scroll is attempted, set this to the previous value
      window.onscroll = function () {
        window.scrollTo(scrollLeft, scrollTop)
      }
    },
    enableMainScroll () {
      window.onscroll = function () {}
    },
    selecionarResposta: function (pergunta, caminho, resposta, pontuacao, imagem, idPergunta) {
      this.disableMainScroll()
      let chatObj = {}
      Object.assign(chatObj, {
        pergunta: pergunta,
        resposta: resposta,
        imagem_nomes: imagem,
        id: idPergunta
      })
      this.chat.push(chatObj)
      pontuacao = parseFloat(pontuacao)
      this.pontuacao += pontuacao
      this.perguntaAtual = this.perguntas.get(caminho)
      if (this.perguntaAtual.final) {
        this.finalizarCaso()
      } else {
        this.$nextTick(() => {
          var topPos = document.getElementsByClassName('final')[0].offsetTop
          document.getElementsByClassName('chat-jaleklinico')[0].scrollTop = topPos - 100
        })
      }
      this.selected = ''
      setTimeout(this.enableMainScroll, 1000)
    },
    finalizarCaso: async function () {
      this.finalizado = true
      let pontuacao = this.pontuacao
      let id = this.jaleklinico.id
      let params = {
        nota: pontuacao,
        jaleklinico_id: id
      }
      this.$nextTick(() => {
        var topPos = document.getElementsByClassName('final')[0].offsetTop
        document.getElementsByClassName('chat-jaleklinico')[0].scrollTop = topPos - 100
      })
      await CasosApi.salvarExecucaoUsuario(params)
      let concluido = 1
      this.concluirTopico(concluido)
    },
    recomecarCaso: function () {
      this.selected = ''
      this.chat = []
      this.perguntaAtual = this.primeiraPergunta
      this.pontuacao = 0
      this.finalizado = false
    },
    modalImagem: function (imagem, idPergunta) {
      this.imagemAtual = imagem
      this.idPerguntaImagem = idPergunta
      this.$nextTick(() => {
        this.$refs.modalJaleklinicoImagem.show()
      })
    },
    obterUrlS3: function (arquivo, idPergunta) {
      arquivo = this.jaleklinico.id + '_' + idPergunta + '_' + arquivo
      return UrlUtils.obterUrlS3(arquivo)
    },
    videoUrl: function (url) {
      let regex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w]+\?v=|embed\/|v\/)?)([\w]+)(\S+)?$/
      if (regex.test(url)) {
        return 'https://www.youtube.com/embed/' + url.match(regex)[5]
      }
    },
    concluirTopico: function (concluido) {
      SalaAulaAPI.atualizarVisualizacaoTopico(this.ementaCurso.topico_escolhido.ementa_id, concluido).then(() => {
        this.$store.dispatch('ementaIdConcluida', this.ementaCurso.topico_escolhido.ementa_id)
      })
    }
  },

  metaInfo () {
    return {
      title: `Jaleko | Jaleklínico | Caso de ${this.jaleklinico.grandes_areas.nome}`,
      meta: [{
        name: 'description',
        content: `${this.jaleklinico.persona}`
      }]
    }
  }
}

</script>
